import { __assign, __makeTemplateObject, __rest } from "tslib";
import MuiTableBody from '@material-ui/core/TableBody';
import React, { forwardRef } from 'react';
import { styled, useThemeProps } from '../../../foundation';
var _RcTableBody = forwardRef(function (props, ref) {
    var _a = useThemeProps({ props: props, name: 'RcTableHead' }), children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(MuiTableBody, __assign({}, rest, { ref: ref }), children));
});
var RcTableBody = styled(_RcTableBody)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcTableBody.displayName = 'RcTableBody';
export { RcTableBody };
var templateObject_1;
